import { SessionStatus as r } from "@waitroom/models";
const m = (e) => `${e.sessionID}-${e.sessionRecurrenceID}`, o = (e, t) => {
  if (t)
    return e && t.find((n) => e === n.id) || t[0];
}, c = (e) => e ? e.primaryHost || o(e.primaryHostUserID, e.hosts) : void 0, s = (e) => e === r.IN_SESSION, f = (e) => e === r.ENDED || e === r.CANCELLED || e === r.ARCHIVED, S = (e, t) => e.findLast((n) => n.state === t), g = (e, t) => !!t && (e == null ? void 0 : e.primaryHostUserID) === t, d = (e) => e ? e.indexOf("meet.google.com") !== -1 ? "google" : e.indexOf("zoom.us") !== -1 ? "zoom" : e.indexOf("teams.microsoft.com") !== -1 || e.indexOf("teams.live.com") !== -1 ? "teams" : "unknown" : "unknown";
export {
  d as getBotType,
  o as getPrimaryHost,
  m as getSessionKey,
  c as getSessionPrimaryHost,
  S as getSessionStateChangeAt,
  s as isSessionActive,
  f as isSessionEnded,
  g as isSessionPrimaryHost
};
